// Owner: account-settings (plan §3.2, §4.8). ⌘K contribution: every settings and account page the
// member may open, found by its name, description or keywords in their language. The search module
// loads on the first query, so nothing of the account area ships with the shell.
import { defineAppCommands } from '../../extensions/commands';

export default defineAppCommands({
  id: 'account.settings',
  providers: [
    {
      id: 'account.settings-pages',
      items: async (query, { signal, listAll }) => {
        if (!query.trim() && !listAll) return [];
        const { settingsCommandItems } = await import('./settings-search');
        if (signal.aborted) return [];
        return settingsCommandItems(query);
      },
    },
  ],
});
